export const VERSION: string = '2.4.0';

interface VersionInfo {
  version: string;
  buildDate: string;
}

export const VERSION_INFO: VersionInfo = {
  version: VERSION,
  buildDate: new Date().toISOString(),
};
